<header
  *ngIf="!hideHeader"
  [ngClass]="{
    headerLogin: isLoginPage,
    headerCaixa: isCaixaFederalLogin,
    mainHeaderCaixa: mainHeaderCaixa
  }"
>
  <div class="container">
    <div class="row align-items-center g-0">
      <!-- logo das páginas (exceto página de login) -->
      <div class="col-lg-3 order-1 col-4" [ngClass]="{ headerAlignLogin: isLoginPage }">
        <!-- logo spe -->
        <div *ngIf="!isCaixa && !isLoginPage">
          <img src="/assets/img/logo-header.svg" (click)="imageClick()" />
        </div>

        <!-- logo caixa -->
        <!-- <div *ngIf="isCaixaFederalLogin && isLoginPage">
          <img src="/assets/cef/logo-header.svg" alt="" (click)="imageClick()">
        </div>-->

        <div *ngIf="isCaixa && !isLoginPage">
          <img src="/assets/cef/logo-header.svg" alt="" (click)="imageClick()" />
        </div>
      </div>

      <!-- botao de conta (a partir de 768px) botão de menu (até 767px) -->
      <!-- coluna invertida com a classe order-lg-3 quando a tela é maior que 767px. -->
      <div class="col-lg-2 col-8 order-2 order-lg-3 text-end">
        <div *ngIf="!isLoginPage">
          <div *ngIf="hide()">
            <div>
              <!-- Botão de menu para desktop (abre um select) -->
              <button
                class="d-none d-lg-inline-flex"
                mat-stroked-button
                [matMenuTriggerFor]="menu"
                [ngClass]="{ caixaMenu: sigla == 'CAIXA' }"
              >
                <div class="menu-button">
                  <span>
                    Conta
                    <img
                      [src]="sigla === 'CAIXA' ? '/assets/icones/azul/conta.svg' : '/assets/icones/vermelho/conta.svg'"
                    />
                  </span>
                </div>
              </button>

              <!-- Botão de menu para mobile (abre um Drawer) -->
              <button
                class="d-lg-inline-flex d-lg-none"
                mat-stroked-button
                (click)="sidenav.toggle()"
                [ngClass]="{ caixaMenu: sigla == 'CAIXA' }"
              >
                <div class="menu-button">
                  <span>
                    Menu
                    <img
                      [src]="sigla === 'CAIXA' ? '/assets/icones/azul/menu.svg' : '/assets/icones/vermelho/menu.svg'"
                    />
                  </span>
                </div>
              </button>
              <mat-menu #menu="matMenu">
                <button *ngIf="!hideAlterarSenha" (click)="goTo('alterar-senha')" mat-menu-item>Alterar senha</button>
                <button (click)="goTo('fale-conosco')" mat-menu-item>Fale conosco</button>
                <button *ngIf="sigla != 'CAIXA'" mat-menu-item (click)="openPdf()">Manual</button>
                <button (click)="openLogoutDialog()" mat-menu-item>Sair</button>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>

      <!-- CNPJ e nome do cliente -->
      <!-- coluna invertida com a classe order-lg-2 quando a tela é maior que 767px. -->
      <div class="col-lg-7 order-3 order-lg-2 text-lg-end my-4 my-lg-0 position-relative">
        <div *ngIf="!isLoginPage">
          <div *ngIf="hide()" class="recuo">
            <div
              *ngIf="!showSelect && flagAlterarSenha !== 'true'"
              [ngClass]="{ caixaColorOneCompany: sigla == 'CAIXA' }"
            >
              <div>{{ companyCNPJ }}</div>
              <div>{{ companyName }}</div>
            </div>

            <!-- select-->
            <div *ngIf="showSelect && flagAlterarSenha !== 'true'" class="font-size-14">
              <div [ngClass]="{ caixaColor: sigla == 'CAIXA' }">
                <div
                  class="ts-click d-flex justify-content-lg-end"
                  (click)="showSearchBar = !showSearchBar ? !showSearchBar : true"
                >
                  <div *ngIf="!showSearchBar" class="ts-click search-bar-min-h d-flex align-items-center">
                    <div>
                      <div class="cursor-pointer">{{ companyCNPJ | cnpj }}</div>
                      <div class="cursor-pointer color-brand-principal">{{ companyName }}</div>
                    </div>
                    <mat-icon
                      matSuffix
                      class="color-brand-principal cursor-pointer d-flex align-self-end ms-1 mb-2 mb-lg-0 align-self-lg-center"
                      >keyboard_arrow_down</mat-icon
                    >
                  </div>

                  <!-- autocomplete de busca cnpj -->
                  <mat-form-field *ngIf="showSearchBar" class="w-100">
                    <mat-label>Buscar por nome ou CNPJ</mat-label>
                    <mat-icon matPrefix>search</mat-icon>
                    <input
                      type="text"
                      [formControl]="autoComplete"
                      [(ngModel)]="selectedOption"
                      matInput
                      [matAutocomplete]="auto"
                    />
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option
                        class="auto-complete-"
                        *ngFor="let option of filteredOptions | async"
                        [value]="option"
                        (click)="click(option)"
                      >
                        <div>{{ getCNPJString(option) | cnpj }}</div>
                        <div class="color-brand-principal">{{ getCompanyString(option) }}</div>
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<!-- container do backdrop do Drawer-->
<div @fadeBackdrop *ngIf="showBackdrop" class="custom-backdrop" (click)="sidenav.close()"></div>

<main class="min-main-height">
  <mat-sidenav-container hasBackdrop="false" class="z-index-up-">
    <!-- container do Drawer -->
    <mat-sidenav
      [(opened)]="drawerOpened"
      (opened)="onDrawerOpened()"
      (closed)="onDrawerClosed()"
      (openedStart)="onDrawerStartOpen()"
      (closedStart)="onDrawerStartClose()"
      position="end"
      #sidenav
      fixedInViewport="true"
      mode="over"
    >
      <button (click)="sidenav.close()" class="ms-2 mt-8" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>

      <mat-nav-list>
        <button
          *ngIf="!loginCommonService.isAprovadorMultiFromStorage()"
          mat-menu-item
          (click)="homeService.navigateTo(''); sidenav.close()"
          class="d-md-inline-flex d-md-none"
        >
          Início
        </button>

        <div
          class="d-lg-inline-flex d-lg-none"
          [hidden]="flagAlterarSenha === 'true'"
          *ngFor="let item of homeService.menusAgrupados"
        >
          <button
            mat-menu-item
            *ngIf="item[0].nome !== 'Quadro Avisos'"
            (click)="homeService.goTo(item[0]); sidenav.close()"
          >
            {{ homeService.nomeItemMenu(item[0].nome) }}
          </button>
        </div>
        <button
          *ngIf="!loginCommonService.isAprovadorMultiFromStorage()"
          class="d-lg-inline-flex d-lg-none"
          mat-menu-item
          (click)="homeService.navigateTo('quadro-de-avisos'); sidenav.close()"
        >
          Notificações
        </button>
        <button
          class="d-lg-inline-flex d-lg-none"
          *ngIf="homeService.showPremiar"
          mat-menu-item
          (click)="homeService.premiar(); sidenav.close()"
        >
          Premiar
        </button>
        <button
          *ngIf="homeService.showRoteirizacao"
          class="d-lg-inline-flex d-lg-none"
          mat-menu-item
          (click)="homeService.roteirizacao(); sidenav.close()"
        >
          Roteirização
        </button>

        <!-- Próprio do Side Nav -->
        <button *ngIf="!hideAlterarSenha" (click)="goTo('alterar-senha'); sidenav.close()" mat-menu-item>
          Alterar senha
        </button>
        <button (click)="goTo('fale-conosco'); sidenav.close()" mat-menu-item>Fale conosco</button>
        <button *ngIf="sigla != 'CAIXA'" mat-menu-item (click)="openPdf(); sidenav.close()">Manual</button>
        <button (click)="openLogoutDialog(sidenav)" mat-menu-item>Sair</button>
      </mat-nav-list>
    </mat-sidenav>
  </mat-sidenav-container>

  <!-- spinner global: LoadingService (dialog showModal / top layer) -->

  <router-outlet></router-outlet>

  <!-- botao de ajuda -->

  <div class="ajuda d-print-none">
    <div class="d-flex flex-column align-items-end gap-2">
      <button
        *ngIf="!isLoginPage && idPartner == '1' && !hideAjuda && accessService.isBetaTesterUser({ forSIG: true })"
        (click)="openChatbot()"
        class="btn btn-ajuda btn-ajuda-ia rounded-pill"
        aria-label="Ajuda IA"
      >
        <span class="btn-ajuda-label">Ajuda IA</span>
        <span class="btn-ajuda-icon"><mat-icon class="color-preto">smart_toy</mat-icon></span>
      </button>

      <button
        *ngIf="!isLoginPage && idPartner == '1' && !hideAjuda"
        (click)="FAB()"
        class="btn btn-ajuda rounded-pill"
        aria-label="Ajuda"
      >
        <span class="btn-ajuda-label">Ajuda</span>
        <span class="btn-ajuda-icon"><img src="/assets/icones/vinho/chat-ajuda.svg" alt="" /></span>
      </button>
    </div>
  </div>
</main>

<!-- footer (escondido na página de login) -->

<footer [class.no-margin-top]="isFuncionarioEditPage" *ngIf="!hideHeader && !isLoginPage">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 d-flex align-items-center">
        <img
          class="img-fluid my-auto"
          [src]="isCaixa ? '/assets/cef/logo-header.svg' : '/assets/img/logo-footer.svg'"
          alt=""
          (click)="imageClick()"
        />
      </div>

      <div class="col-lg-6 text-end d-none d-lg-block">
        <button mat-button (click)="faleConosco()">Fale Conosco</button>
        <button *ngIf="!isCaixa" mat-button (click)="manual()">Manual</button>
      </div>
    </div>
  </div>
</footer>
